export default "__VITE_ASSET__a80e7946__"